import styled from "styled-components";

const VisuallyHiddenInput = styled('input')({
    width: 0
});

export default VisuallyHiddenInput